export default "__VITE_ASSET__dFGnFpjz__"